import React from "react";

const Logo = ({
  src,
  alt = "Logo",
  className = "w-20 h-auto",
  align,
}) => {
  return (
    <img
      src={src}
      alt={alt}
      loading="eager"
      className={`${className} ${align === "right" ? "ml-auto" : ""}`}
    />
  );
};

export default Logo;



